export const updateRoute = (pathname) => {
  return { type: "updateRoute", payload: pathname };
};

export const clearRoute = () => {
  return { type: "clearRoute" };
};
